/**
 * Accordion — Generic toggle for FAQ section, PDP specs, PDP FAQ
 * Works with [data-accordion] containers.
 * Each item: [data-accordion-item] > [data-accordion-trigger] + [data-accordion-content]
 */
(function () {
  'use strict';

  function initAccordion(container) {
    // Guard against double-initialization
    if (container.hasAttribute('data-accordion-initialized')) return;
    container.setAttribute('data-accordion-initialized', 'true');

    var items = container.querySelectorAll('[data-accordion-item]');
    var allowMultiple = container.hasAttribute('data-accordion-multiple');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var content = item.querySelector('[data-accordion-content]');
      var chevron = item.querySelector('.accordion-chevron');

      if (!trigger || !content) return;

      // Set up ARIA relationships
      var contentId = content.id || ('accordion-content-' + Math.random().toString(36).slice(2, 8));
      content.id = contentId;
      trigger.setAttribute('aria-controls', contentId);
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', trigger.id || '');

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // If single mode, close all others
        if (!allowMultiple && !isOpen) {
          items.forEach(function (otherItem) {
            var otherTrigger = otherItem.querySelector('[data-accordion-trigger]');
            var otherContent = otherItem.querySelector('[data-accordion-content]');
            var otherChevron = otherItem.querySelector('.accordion-chevron');
            if (otherItem !== item && otherTrigger) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              otherTrigger.classList.remove('text-accent');
              if (otherContent) otherContent.style.maxHeight = '0';
              if (otherChevron) otherChevron.style.transform = 'rotate(0deg)';
            }
          });
        }

        // Toggle this item
        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.classList.remove('text-accent');
          content.style.maxHeight = '0';
          if (chevron) chevron.style.transform = 'rotate(0deg)';
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          trigger.classList.add('text-accent');
          content.style.maxHeight = content.scrollHeight + 'px';
          if (chevron) chevron.style.transform = 'rotate(180deg)';
        }
      });
    });
  }

  // Initialize all accordions on the page
  document.querySelectorAll('[data-accordion]').forEach(initAccordion);

  // Re-initialize when new sections are added (Shopify section rendering)
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            var accordions = node.querySelectorAll ? node.querySelectorAll('[data-accordion]') : [];
            accordions.forEach(initAccordion);
            if (node.hasAttribute && node.hasAttribute('data-accordion')) {
              initAccordion(node);
            }
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
